export const blogExpertBadgeComponent = {
  key: 'blogExpertBadgeComponent',
  name: 'Blog expert badge Dept-Component',
  siteIdentifier: 'global',

  expertBadgeLabel: 'PetSafe® Expert',
  expertBadgeIconAlt: 'Icon Expert Badge',
};
